export default {
  positiveNumbers: /^([0-9]+\.?[0-9]*|\.[0-9]+)$/, // numeros enteros y decimales positivos
  cuitFormat: /^[0-9]{2}-[0-9]{8}-[0-9]$/, // formato de cuit
  hexadecimalColorFormat: /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/, // Formato de colores hexadecimales, empieza con #
};
